module.exports = __webpack_public_path__ + "img/project_icno2.cb287433.png";